import { apiClient, loadAuthConfig } from "../../shared/api/clients";
import { BiUser, LoginDto } from "./types";

/** Au-delà, le serveur est considéré injoignable (écran « Réessayer » au lieu d'un chargement infini). */
const AUTH_TIMEOUT_MS = 10_000;

export type { AuthConfig } from "../../shared/api/clients";

/** GET /auth/config — configuration du client (url_backend_bi, nom_cube), en cache. */
export const getAuthConfig = loadAuthConfig;

interface LoginResponse {
  success?: boolean;
  message?: string;
  data?: {
    token?: string;
    Token?: string;
    user?: BiUser;
    User?: BiUser;
  };
}

export interface LoginSession {
  token: string | null;
  user: BiUser | null;
}

/** POST /auth/login — appel public : un 401 (identifiants invalides) ne déconnecte pas. */
export async function login(dto: LoginDto): Promise<LoginSession> {
  const { data } = await apiClient.post<LoginResponse>("/auth/login", dto, {
    auth: false,
    timeoutMs: AUTH_TIMEOUT_MS,
  });
  const payload = data?.data;
  return {
    token: payload?.token ?? payload?.Token ?? null,
    user: payload?.user ?? payload?.User ?? null,
  };
}

interface VerifyResponse {
  success?: boolean;
  data?: Record<string, unknown>;
}

export interface SessionInfo {
  /** Le backend a confirmé que le token est valide. */
  valid: boolean;
  role: string;
  depot: string;
}

const pickString = (obj: Record<string, unknown>, keys: string[]): string => {
  for (const k of keys) {
    const v = obj[k];
    if (typeof v === "string" && v) return v;
  }
  return "";
};

/** GET /auth/verify — rôle et dépôt de l'utilisateur connecté (source de vérité serveur). */
export async function verifySession(): Promise<SessionInfo> {
  const { data } = await apiClient.get<VerifyResponse>("/auth/verify", {
    timeoutMs: AUTH_TIMEOUT_MS,
  });
  const d = data?.data ?? {};
  return {
    valid: data?.success === true,
    role: pickString(d, ["role", "Role", "profil", "Profil"]),
    depot: pickString(d, ["depot", "Depot", "codDepot", "CodDepot"]),
  };
}
